module.exports = __webpack_public_path__ + "static/media/519.54830ff3.webp";